import { Link } from 'react-router-dom';

export const Card = ({ post, getPostDetail }) => {
    const handlePost = () => getPostDetail(post);

    return (
        <Link className='blog-card' to={`/blog/${post?.uuid}`} onClick={handlePost}>
            <div className='card-title'>{post?.title}</div>
        </Link>
    );
};
